import { FLAVOR_SELECTOR_CLASS } from '../../classnames/above-the-fold';
import Radio from '../../design-system/radio';
import isExcludedFromSubscription from '../../utils/excluded-from-subscription';

export default class VariantHandler {
  constructor(containers) {
    this.containers = containers;
  }

  global = true;

  radioButton = new Radio();

  handle = ({ currentVariant }) => {
    if (currentVariant == null) {
      return;
    }

    const currentVariantId = currentVariant.variantId;
    this.containers.forEach((container) => {
      const variantRadios = [
        ...container.querySelectorAll(`.${FLAVOR_SELECTOR_CLASS}[value="${currentVariantId}"]`)
      ];

      variantRadios.forEach((radio) => {
        this.radioButton.removeSelection(radio, container);
        this.radioButton.addSelection(radio, container);
      });

      this.runHandlers(currentVariantId, container);
    });
  };

  runHandlers = (variantId, container) => {
    const variantData = window.variantDataSelector.getData(variantId);

    this.handlers.forEach((handler) => handler.handle(variantData, container));
  };

  handleClick = (event, container) => {
    const { target: { dataset: { variantId }}} = event;

    this.runHandlers(variantId, container);

    if (this.global) {
      const variantData = window.variantDataSelector.getData(variantId);

      if (isExcludedFromSubscription(variantId)) {
        window.currentVariantStorage.setState({ currentVariant: variantData, subscription: 'one-time' });
      } else {
        window.currentVariantStorage.setCurrentVariant(variantData);
      }
    }
  };

  initializeEventListeners = () => {
    [...this.containers].forEach((container) => {
      const variantSelectors = container.getElementsByClassName(FLAVOR_SELECTOR_CLASS);

      [...variantSelectors].forEach((element) => {
        element.addEventListener('click', (event) => {
          this.handleClick(event, container);
        });
        if (isExcludedFromSubscription(element.dataset.variantId) && element.getAttribute('selected') === 'true') {
          this.handleClick({ target: element }, container);
        }
      });
    });

    if (this.global) {
      window.currentVariantStorage.subscribe(this);
    }
  };
}
